export class SpecialSettingConfig {
    pointOfSaleOid: number;
    validity: {
        always: boolean,
        from: string,
        to: string
    };
    daysInAdvance: number;
    minRentalLength: number;
    maxRentalLength: number;
    status: string;
    name: string;
    period: any =  {
        from: Date,
        to: Date
    };
    oid;
    dateConfigRange:string="date_range";

    constructor(){
        this.pointOfSaleOid = -1;
        this.validity = {
            always: false,
            from: null,
            to: null
        };
        this.oid = null;
        this.daysInAdvance = 0;
        this.minRentalLength = 1;
        this.maxRentalLength = 30;
        this.status = 'new';
        this.name = '';
        this.period = {
            from: null,
            to: null
        };
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/restrictions/special-settings/special-setting.ts